import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Inbox = function Inbox(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M37 30H11V26C11 24.9 10.1 24 9 24H4V22H9C11.2 22 13 23.8 13 26V28H35V26C35 23.8 36.8 22 39 22H44V24H39C37.9 24 37 24.9 37 26V30Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 41H7C4.8 41 3 39.2 3 37V22.725L12.2 7H35.8L45 22.725V37C45 39.2 43.2 41 41 41ZM5 23.275V37C5 38.1 5.9 39 7 39H41C42.1 39 43 38.1 43 37V23.275L34.65 9H13.35L5 23.275Z",
      fill: color
    })]
  });
};
export default Inbox;